const QuickPayMode = {
  OFF: "OFF",
  ON: "ON",
  ALWAYS_ON: "ALWAYS_ON",
} as const;

type QuickPayMode = (typeof QuickPayMode)[keyof typeof QuickPayMode];

export default QuickPayMode;
export type { QuickPayMode };
